var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2125 34.25H56.25V15.5C56.25 13.4375 54.5625 11.75 52.5 11.75H37.5C35.4375 11.75 33.75 13.4375 33.75 15.5V34.25H27.7875C24.45 34.25 22.7625 38.3 25.125 40.6625L42.3375 57.875C43.8 59.3375 46.1625 59.3375 47.625 57.875L64.8375 40.6625C67.2 38.3 65.55 34.25 62.2125 34.25ZM18.75 71.75C18.75 73.8125 20.4375 75.5 22.5 75.5H67.5C69.5625 75.5 71.25 73.8125 71.25 71.75C71.25 69.6875 69.5625 68 67.5 68H22.5C20.4375 68 18.75 69.6875 18.75 71.75Z",
    fill: "#008894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f9fa338140e3b5cdf88fc9c744912a74.svg";
export { ForwardRef as ReactComponent };